import React from 'react';
import translate from '../../../i18n/translate';
import moment from "moment";
import { google, ics } from "calendar-link";
import { IGenerateLink } from "../../../interfaces";
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import AddOutlinedIcon from '@material-ui/icons/AddOutlined';
import { AiFillApple, AiOutlineGoogle } from "react-icons/ai";
import { SiMicrosoftoutlook } from "react-icons/si";


export const openTooltip = (e: any, id: string, setAddToCalendar: any) => {
    e.stopPropagation();
    setAddToCalendar(id);
  };

export const OpenTooltipSessions = ({ session, setAddToCalendar }: any) => {
  return (
    <>
      {!session.isEnabled && (
        <div className="twt-addToCalendar" onKeyDown={() => {}} onClick={(e: any) => openTooltip(e, session.id, setAddToCalendar)}>
          <AddOutlinedIcon style={{ fontSize: 20 }} />
          <span className="twt-calendar-text">{translate("twt_add_to_calendar")}</span>
        </div>
      )}
    </>
  );
};
export const handleClick = (calendarName: string, sessionId: string, upcomingSessions: any, allInfo: any) => {
  const session = upcomingSessions.find((x: { id: string }) => x.id === sessionId);

  if (!session) {
    return; // Exit early if session is not found
  }

  const instructionUrl: any = getInstructionUrl(allInfo.common.selectedLanguage);
  const faqUrl: any = getFaqUrl(allInfo.common.selectedLanguage);
  const twtLink: any = getTwtLink(calendarName);

  const calendarDescription = generateCalendarDescription(session, allInfo, twtLink, instructionUrl, faqUrl);

  const event: IGenerateLink = {
    title: "Talk with the Teacher Upcoming Session",
    description: calendarDescription,
    start: session.startTime,
    duration: [1, "hour"],
    location: `${process.env.REACT_APP_TWT_URL}`,
  };

  openCalendarEvent(calendarName, event);
};

export const getInstructionUrl = (selectedLanguage: string) => {
  const languageSegment = selectedLanguage === "EN" ? "EN-EN" : selectedLanguage;
  return `<a href='${process.env.REACT_APP_GE_SUPPORT_URL}/${languageSegment}/solutions/one/twt'>${process.env.REACT_APP_GE_SUPPORT_URL}/${languageSegment}/solutions/one/twt</a>`;
};

const getFaqUrl = (selectedLanguage: string) => {
  return `<a href='${process.env.REACT_APP_ASSETS_URL}/halo/twt/twt_${selectedLanguage.toLowerCase()}.pdf'>${process.env.REACT_APP_ASSETS_URL}/halo/twt/twt_${selectedLanguage.toLowerCase()}.pdf</a>`;
};

export const getTwtLink = (calendarName: string) => {
  return calendarName === "google" ? `<a href='${process.env.REACT_APP_TWT_URL}'>${process.env.REACT_APP_TWT_URL}</a>` : process.env.REACT_APP_TWT_URL;
};

const generateCalendarDescription = (session: any, allInfo: any, twtLink: string, instructionUrl: string, faqUrl: string) => {
  const username = allInfo.peopleInformation.data.getpeopleInformation.username;
  const topicName = session.topic ? session.topic.name : "Topic name not available";
  const date = session.topic ? moment(session.startTime).format("DD MMMM YYYY") : "Not available";
  const startTime = moment(session.startTime).format("hh:mm A");

  return `Hello ${username},
  \nHere are the details about your upcoming Talk With Teacher session:
  \nTopic: ${topicName}.
  \nDate: ${date}
  \nStart Time: ${startTime}
  \nPlease click: ${twtLink}
  \nWe strongly recommend that you read our Class Policy, ${instructionUrl}, ${faqUrl}, 
  \nEnjoy your Talk with the Teacher session
  \nThe Learnship Team`;
};

const openCalendarEvent = (calendarName: string, event: IGenerateLink) => {
  if (calendarName === "outlook" || calendarName === "apple") {
    window.open(ics(event));
  } else if (calendarName === "google") {
    window.open(google(event));
  }
};


export function CalendarComponent({
  showAddToCalendar,
  session,
  setAddToCalendar,
  handleClick,
  upcomingSessions,
  allInfo,
}: any): any {
  return (
    showAddToCalendar === session.id && (
      <ClickAwayListener onClickAway={() => setAddToCalendar('')}>
        <div className="calContent">
          <div className="caltriangle-up">
            <span className="caltriangle-inner"></span>
          </div>
          <SiMicrosoftoutlook
            data-testid="outlook-icon"
            className="calendarLink"
            onClick={() => handleClick('outlook', session.id, upcomingSessions, allInfo)}
          ></SiMicrosoftoutlook>
          <AiFillApple
            data-testid="apple-icon"
            className="calendarLink"
            onClick={() => handleClick('apple', session.id, upcomingSessions, allInfo)}
          ></AiFillApple>
          <AiOutlineGoogle
            data-testid="google-icon"
            className="calendarLink"
            onClick={() => handleClick('google', session.id, upcomingSessions, allInfo)}
          ></AiOutlineGoogle>
        </div>
      </ClickAwayListener>
    )
  );
}